import React from "react";
import {
  Typography,
  Box,
  Button,
  Stack,
  styled,
  useMediaQuery,
  Theme,
} from "@mui/material";
import { IconSettings2 } from "@tabler/icons-react";

// third party
import { motion } from "framer-motion";

const StyledButton = styled(Button)(() => ({
  padding: "13px 48px",
  fontSize: "16px",
}));

const BannerContent = () => {
  const lgDown = useMediaQuery((theme: Theme) => theme.breakpoints.down("lg"));

  return (
    <Box mt={lgDown ? 8 : 0}>
      <motion.div
        initial={{ opacity: 0, translateY: 550 }}
        animate={{ opacity: 1, translateY: 0 }}
        transition={{
          type: "spring",
          stiffness: 150,
          damping: 30,
        }}
      >
        <Typography variant="h6" display={"flex"} gap={1} mb={2}>
          <Typography color={"secondary"}>
            <IconSettings2 size={"21"} />
          </Typography>{" "}
          Kick start your project with
        </Typography>

        <Typography
          variant="h1"
          fontWeight={900}
          sx={{
            fontSize: {
              md: "54px",
            },
            lineHeight: {
              md: "60px",
            },
          }}
        >
          Most powerful &{" "}
          <Typography component={"span"} variant="inherit" color={"primary"}>
            Developer friendly
          </Typography>{" "}
          NextJs dashboard
        </Typography>
      </motion.div>
      <Box pt={4} pb={3}>
        <motion.div
          initial={{ opacity: 0, translateY: 550 }}
          animate={{ opacity: 1, translateY: 0 }}
          transition={{
            type: "spring",
            stiffness: 150,
            damping: 30,
            delay: 0.2,
          }}
        >
          <Typography variant="h5" fontWeight={300}>
            Modernize comes with light & dark color skins, well designed
            dashboards, applications and pages.
          </Typography>
        </motion.div>
      </Box>
      <motion.div
        initial={{ opacity: 0, translateY: 550 }}
        animate={{ opacity: 1, translateY: 0 }}
        transition={{
          type: "spring",
          stiffness: 150,
          damping: 30,
          delay: 0.4,
        }}
      >
        <Stack direction={{ xs: "column", sm: "row" }} spacing={2} mt={3}>
          <StyledButton
            variant="contained"
            color="primary"
            href="/auth/auth1/login"
          >
            Login
          </StyledButton>

          <StyledButton
            variant="outlined"
            // href="/auth/auth1/signup"
          >
            Sign Up
          </StyledButton>
        </Stack>
      </motion.div>
    </Box>
  );
};

export default BannerContent;
